import type { ReactNode } from "react";
import { HashRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { CaptureScreen } from "./screens/CaptureScreen";
import { ReviewScreen } from "./screens/ReviewScreen";
import { TrendScreen } from "./screens/TrendScreen";
import { FlexScreen } from "./screens/FlexScreen";
import { FlexResultScreen } from "./screens/FlexResultScreen";
import { BrandGlyph } from "./components/BrandGlyph";
import { PilotGate } from "./components/PilotGate";

function Shell({ children }: { children: ReactNode }) {
  const location = useLocation();
  const inFlex = location.pathname.startsWith("/flex");
  return (
    <div className="app">
      <div className="topbar">
        <Link to={inFlex ? "/flex" : "/"} className="brand" style={{ color: "inherit" }}>
          <BrandGlyph size={30} />
          <h1>
            CADtomie <span className="thin">{inFlex ? "Flex" : "Gait"}</span>
          </h1>
        </Link>
        <span className="row" style={{ gap: 10, marginLeft: "auto" }}>
          <Link to="/" className={`mode-link ${!inFlex ? "active" : ""}`}>
            Gait
          </Link>
          <Link to="/flex" className={`mode-link ${inFlex ? "active" : ""}`}>
            Flex
          </Link>
          <span className="tag">on-device · private</span>
        </span>
      </div>
      {children}
    </div>
  );
}

export function App() {
  return (
    <HashRouter>
      <Shell>
        <PilotGate>
          <Routes>
            <Route path="/" element={<CaptureScreen />} />
            <Route path="/review/:sessionId" element={<ReviewScreen />} />
            <Route path="/trend/:patientId" element={<TrendScreen />} />
            <Route path="/flex" element={<FlexScreen />} />
            <Route path="/flex/review/:sessionId" element={<FlexResultScreen />} />
          </Routes>
        </PilotGate>
      </Shell>
    </HashRouter>
  );
}
